import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { faTimes, faChevronDown, faSearch } from '@fortawesome/free-solid-svg-icons';


@Component({
    selector: 'app-selector',
    templateUrl: './selector.component.html',
    styleUrls: ['./selector.component.less'],
    standalone: false
})
export class SelectorComponent implements OnInit, OnChanges {

  faTimes = faTimes;
  faChevronDown = faChevronDown;
  faSearch = faSearch;

  constructor() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.selected  && !this.multiple)
      this.toogleSelection(changes.selected.currentValue);
    else if(changes?.selected && this.multiple) {
      var temp = changes.selected.currentValue;
      this.selected = [];
      this.list = this.selection;
      temp.forEach(el => {
        this.toogleSelection(el);
      });
    }
    if(changes?.selection?.currentValue) {
      this.selection = changes.selection.currentValue;
      this.toogleSearch();
    }
    if(changes?.disable?.currentValue) {
      this.disable = changes.disable.currentValue;
      if(this.disable)
        this.toogleDisplay();
    }
  }

  display: boolean = false;

  list: any[] = [];
  
  @Input() multiple: boolean = false;

  @Input() selection: any[] = [];

  @Input() selected: any = null;

  @Input() title: string= "Titulo";

  @Input() disable: boolean = false;

  @Output() selectedChange: EventEmitter<any> = new EventEmitter<any>();

  @Output() change: EventEmitter<string> = new EventEmitter<string>();

  output: any = "";

  search: string = "";

  ngOnInit() {
    this.list = this.selection;
  }

  pop(item) {
    this.list.push(this.selected[item]);
    this.selected.splice(item,1);
    this.selectedChange.emit(this.selected);
    this.change.emit(this.title);
  }

  toogleDisplay() {
    var fa = document.getElementById("fa"+this.title);
    if(!this.disable)
      this.display = !this.display;
    else{
      this.display = false;
      this.list = this.selection;
      this.selected = null;
    }
    if(this.display) {
      fa.classList.replace("fa-chevron-down", "fa-chevron-up");
    }else{
      fa.classList.replace("fa-chevron-up", "fa-chevron-down");
    }
  }

  toogleSearch() {
    this.list = this.selection.filter(x => x.toString().toLowerCase().includes(this.search.toLowerCase())  && x.toString() != this.output.toString());
  }

  toogleSelection(sel) {
    if(this.multiple) {
      this.selected.push(sel);
      this.list = this.list.filter(x => x.toString() != sel.toString());
      this.selectedChange.emit(this.selected);
      this.change.emit(this.title);
    }else{
      this.selected = sel;
      this.list = this.selection.filter(x => x.toString() != sel.toString());
      this.selectedChange.emit(this.selected);
      this.change.emit(this.title);
    }
  }

}
